export default "__VITE_ASSET__D879SLte__"